"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemWarningFlag_1 = require("../../model/WindowItemWarningFlag");

var WindowImportWindowIdentification_1 = require("../model/WindowImportWindowIdentification");

var WindowImportWindowIdentificationConverter_1 = require("./WindowImportWindowIdentificationConverter");
/**
 * @author OPt
 */


var WindowImportWindowIdentificationConverterImpl =
/*#__PURE__*/
function (_WindowImportWindowId) {
  _inherits(WindowImportWindowIdentificationConverterImpl, _WindowImportWindowId);

  function WindowImportWindowIdentificationConverterImpl() {
    _classCallCheck(this, WindowImportWindowIdentificationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowImportWindowIdentificationConverterImpl).apply(this, arguments));
  }

  _createClass(WindowImportWindowIdentificationConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        startDate: conversions.fromDate(source.startDate),
        endDate: conversions.fromDate(source.endDate),
        productCount: source.productCount,
        warningFlags: source.warningFlags.serialize()
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowImportWindowIdentification_1.WindowImportWindowIdentification(WindowImportWindowIdentification_1.WindowImportWindowIdentification.schema.id.valueOf(conversions.documentToClassId(source)), WindowImportWindowIdentification_1.WindowImportWindowIdentification.schema.name.valueOfField(source), WindowImportWindowIdentification_1.WindowImportWindowIdentification.schema.startDate.valueOfField(source), WindowImportWindowIdentification_1.WindowImportWindowIdentification.schema.endDate.valueOfField(source), WindowImportWindowIdentification_1.WindowImportWindowIdentification.schema.productCount.valueOfField(source), conversions.asFlagSet(source.warningFlags, WindowItemWarningFlag_1.WindowItemWarningFlag));
    }
  }]);

  return WindowImportWindowIdentificationConverterImpl;
}(WindowImportWindowIdentificationConverter_1.WindowImportWindowIdentificationConverter);

exports.WindowImportWindowIdentificationConverterImpl = WindowImportWindowIdentificationConverterImpl;